import GeneralDataBox from './GeneralDataBox';

export type { GeneralDataBoxProps } from './GeneralDataBox';

export default GeneralDataBox;
